import assign from 'lodash/assign';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import uiRouter from '@uirouter/angularjs';

import { LogoModule } from 'components/logo/logo.module';
import { OnboardingServiceModule } from 'services/data/onboarding.service';
import { LaunchDarklyServiceModule } from 'services/access/launchDarkly/launchDarkly.service';
import { LaunchChangePlanServiceModule } from 'components/changePlan/launchChangePlan.service';
import { NOT_TRIAL } from 'components/trial/trial.service';
import { NavigationMenuServiceModule } from './services/navigationMenu.service';
import { NAV_STATES } from './navigationMenu.constants';

import template from './navigationMenu.html';
import './navigationMenu.scss';

export const NavigationMenuComponentModule = angular
    .module('app.components.navigationMenu', [
        'ngMaterial',
        LogoModule,
        NavigationMenuServiceModule,
        OnboardingServiceModule,
        LaunchDarklyServiceModule,
        LaunchChangePlanServiceModule,
        uiRouter
    ]).component('navigationMenu', {
        template,
        bindings: {
            showProgressBar: '<',
            progressBarValue: '<',
            trialStatus: '<'
        },
        controller: class SidenavLinksCtrl {
            constructor(
                $scope,
                $rootScope,
                $state,
                $window,
                $mdSidenav,
                $mdMedia,
                onboardingService,
                navigationMenuService,
                auth0SdkService,
                launchDarklyService,
                launchChangePlanService
            ) {
                assign(this, {
                    $scope,
                    $rootScope,
                    $state,
                    $window,
                    $mdSidenav,
                    $mdMedia,
                    onboardingService,
                    navigationMenuService,
                    auth0SdkService,
                    launchDarklyService,
                    launchChangePlanService,
                    NAV_STATES,
                    myAccountLabel: 'MYACCOUNT.TITLE',
                    smallNavStates: [
                        NAV_STATES.EDIT_STORE,
                        NAV_STATES.BLOCK_MANAGEMENT,
                        NAV_STATES.SITE_DESIGNER
                    ],
                    hiddenApps: []
                });
            }

            $onInit() {
                this.navigationMenuService.loadApps()
                    .then((apps) => { this.apps = apps; });
                this.onStateChangeSuccess = this.onStateChangeSuccess.bind(this);
                this.setUserName();
                this.setUserInitials();
                this.unbindRootStateChange = this.$rootScope.$on('$stateChangeSuccess', this.onStateChangeSuccess);
                const asyncLookup = true;
                this.$mdSidenav('nav-menu', asyncLookup).then((navMenu) => {
                    navMenu.onClose(() => {
                        this.navigationMenuService.removeNavOpenCssClassFromBody();
                    });
                    this.updateNavigationView();
                });
            }

            $onChanges(changes) {
                if (changes.trialStatus) this.setIsTrial();
            }

            shouldShowApp(app) {
                const showApp = !this.hiddenApps.includes(app);
                return app !== 'progress' && app !== 'get-started' && showApp;
            }

            setIsTrial() {
                this.isTrial = angular.isDefined(this.trialStatus) && this.trialStatus !== NOT_TRIAL;
            }

            shouldShowProgressBar() {
                return this.isTrial && this.showProgressBar;
            }

            trialStatusAsNumber() {
                if (this.isTrialExpired()) return '0';

                let status = parseInt(this.trialStatus);
                if (isNaN(status)) return '0';

                return status;
            }

            isTrialExpired() {
                return this.trialStatus === 'PARKED' || this.trialStatus === 'EXPIRED';
            }

            onStateChangeSuccess() {
                this.navigationMenuService.close();
                if (this.clickedIndex !== null && this.clickedIndex !== undefined) {
                    this.apps[this.clickedIndex].clicked = false;
                }
                this.updateNavigationView();
            }

            $onDestroy() {
                this.unbindRootStateChange();
            }

            updateNavigationView() {
                this.selectedAppType = this.navigationMenuService.getSelectedAppType(this.$state.$current.name);
                this.navigationMenuService.setNavMenuMarginOnElements(this.selectedAppType);
            }

            goToApp(app, $index) {
                if (app.link === this.$state.current.name) {
                    return;
                }
                this.clickedIndex = $index;
                this.apps[$index].clicked = true;
                this.$window.dataLayer.push({
                    event: `admin_navMenu-${app.type}`
                });

                if (app.param) {
                    return this.$state.go(app.link, app.param).catch(() => {
                        this.apps[$index].clicked = false;
                    });
                } else if (app.href) { // supports URLs only in the new admin client
                    this.$window.location.href = app.href;
                } else {
                    return this.$state.go(app.link).catch(() => {
                        this.apps[$index].clicked = false;
                    });
                }
            }

            setUserName() {
                this.auth0SdkService.getUser().then((user) => {
                    if (user && user.user_metadata) {
                        const { firstname, lastname } = user.user_metadata;
                        this.myAccountLabel = `${firstname}\n\r${lastname}`;
                    }
                });
            }

            setUserInitials() {
                this.auth0SdkService.getUser().then((user) => {
                    if (user && user.user_metadata) {
                        const { firstname, lastname } = user.user_metadata;
                        if (isEmpty(firstname) || isEmpty(lastname)) {
                            this.myInitials = null;
                        } else {
                            this.myInitials = `${firstname[0].toUpperCase()}${lastname[0].toUpperCase()}`;
                        }
                    }
                });
            }

            isFullNavVisible() {
                return !(this.showSmallMenu() && this.$mdMedia('gt-sm'));
            }

            showSmallMenu() {
                return includes(this.smallNavStates, this.selectedAppType);
            }

            showFullMenu() {
                return (
                    this.selectedAppType !== this.NAV_STATES.EDIT_STORE &&
                    this.selectedAppType !== this.NAV_STATES.VOLUSION_PAYMENTS
                );
            }

            hideMenu() {
                return this.selectedAppType === this.NAV_STATES.VOLUSION_PAYMENTS;
            }

            openPlans(ev) {
                this.launchChangePlanService.openModal(ev, null, true);
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/navigationMenu/navigationMenu.component.js